<template>
  <div class="home">
    <Banner/>
    <ArticleGroup />
  </div>
</template>

<script>

import Banner from "../components/Banner.vue";
import ArticleGroup from "../components/ArticleGroup.vue";

export default {
   components: {
     ArticleGroup,
     Banner
   }
}
</script>
<style scoped>

@media screen and (min-width: 768px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    position: relative;
    clip: rect(89px,1400px,709px,0px);
    top: -37px
  }
}
@media only screen and (max-width: 600px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    top:45px;
  }
}
@media only screen and (min-width: 600px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    position: relative;
    clip: rect(89px,1400px,709px,0px);
    top: -37px
  }
}
.outerDiv{
  padding: 8px 0px 0px 100px;
}
.innerDiv{  

}
.bannerImage{
  height:100%;
  display: inline-block;
}
.articleHeading{
  font-size: 3vw;
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  color: #504f4f;
}
</style>
